import React from "react";
import './Advertising.css';

function Advertising() {
    
    return (
        <div className="container-advertising">
            <img id="advertising" src="https://relojes-s-l.s3.us-west-1.amazonaws.com/Black+Friday+2025+-+1.JPEG" alt=""></img>
        </div>
    )
};

export default Advertising;